import { useEffect, useState } from "react";
import Lenis from "lenis";
import { AnimatePresence, motion } from "framer-motion";
import { content } from "./data/content";
import { Navbar } from "./components/site/Navbar";
import { Hero } from "./components/site/Hero";
import { Marquee } from "./components/site/Marquee";
import { Bio } from "./components/site/Bio";
import { Services } from "./components/site/Services";
import { Studios } from "./components/site/Studios";
import { Faq } from "./components/site/Faq";
import { Footer } from "./components/site/Footer";

function App() {
  const [lang, setLang] = useState("it");
  const t = content[lang];

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <div className="min-h-screen bg-[#FAF9F5] font-body text-[#1E2721]">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar t={t} lang={lang} setLang={setLang} />
      <AnimatePresence mode="wait">
        <motion.main
          key={lang}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
        >
          <Hero t={t} />
          <Marquee items={t.marquee} />
          <Bio t={t} />
          <Services t={t} lang={lang} />
          <Studios t={t} />
          <Faq t={t} lang={lang} />
          <Footer t={t} />
        </motion.main>
      </AnimatePresence>
    </div>
  );
}

export default App;
